import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 34,
  height: 34,
}

const Gym = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 33.499 33.499'
  >
    <g fill={color}>
      <path
        transform='translate(-276.911 -178.904)'
        d='M301.693,191.619a.654.654,0,1,0,0,.925A.655.655,0,0,0,301.693,191.619Z'
      />
      <path
        transform='translate(0 -0.001)'
        d='M32.731,12.8l-.925-.925a3.273,3.273,0,0,0,.079-4.705L31.422,6.7l.462-.463A3.271,3.271,0,1,0,27.26,1.614l-.463.463-.463-.463a3.269,3.269,0,0,0-4.627,0l-.079.079L20.7.768a2.617,2.617,0,0,0-3.7,3.7l3.7,3.7L8.169,20.7,4.468,17a2.617,2.617,0,1,0-3.7,3.7l.925.925-.079.079a3.269,3.269,0,0,0,0,4.627l.463.463-.462.463a3.271,3.271,0,1,0,4.625,4.626l.463-.463.463.463a3.268,3.268,0,0,0,4.627,0l.079-.079.925.925a2.617,2.617,0,1,0,3.7-3.7l-3.7-3.7L25.329,12.8l3.7,3.7a2.617,2.617,0,1,0,3.7-3.7ZM28.185,2.539A1.962,1.962,0,0,1,30.96,5.315l-.462.463L27.722,3Zm-5.552,0a1.961,1.961,0,0,1,2.776,0L30.96,8.091a1.961,1.961,0,0,1,0,2.776l-.079.079L22.554,2.619ZM5.313,30.961a1.962,1.962,0,0,1-2.775-2.775L3,27.723,5.776,30.5Zm5.552,0a1.961,1.961,0,0,1-2.776,0L2.538,25.41a1.961,1.961,0,0,1,0-2.776l.079-.079,8.327,8.327Zm4.706-1a1.308,1.308,0,0,1-1.851,1.85L1.692,19.779a1.308,1.308,0,1,1,1.85-1.851Zm-3.7-5.552L9.094,21.63,21.628,9.1,24.4,11.871Zm19.936-8.833a1.307,1.307,0,0,1-1.85,0L17.927,3.543a1.308,1.308,0,0,1,1.851-1.85L31.806,13.721A1.308,1.308,0,0,1,31.805,15.572Z'
      />
      <path
        transform='translate(-174.898 -205.337)'
        d='M197.83,219.9a.654.654,0,0,0-.925,0l-5.291,5.291a.654.654,0,0,0,.925.925l5.291-5.291A.654.654,0,0,0,197.83,219.9Z'
      />
    </g>
  </svg>
)

export default Gym
